<!-- @format -->

<template>
    <BaseSlice
        v-bind="navigationAttributes"
        :slice-type="slice.slice_type"
        :slice-index="slice.index"
        class="gst-slice-simple-content pb-2">
        <PrismicRichText
            v-if="isRichTextNotEmpty(slice.primary.title)"
            :field="slice.primary.title"
            class="gst-slice-simple-content__title" />
        <PrismicRichText
            :field="slice.primary.content"
            class="gst-slice-simple-content__content" />
    </BaseSlice>
</template>

<script>
import NavMixin from '@tenant/app/slices/mixins/NavMixin.js';
import FieldMixin from '@tenant/app/slices/mixins/FieldMixin.js';

export default {
    name: 'SimpleContent',
    mixins: [NavMixin, FieldMixin],
    props: {
        slice: {
            type: Object,
            default: null,
        },
    },
};
</script>
